import { AlertBox, Button, DatePicker } from "@life-line-lab/components-react";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import errorHandler from "Utils/error-handler";
import { DeliveryDateModalSchema } from "./delivery-date-modal-validation";
import { Moment } from "moment";

type InputData = { deliveryDate: Moment | string };
type SubmitData = { deliveryDate: Moment | string; orderID: string };

interface DeliveryDateModalProps {
  onClose: () => void;
  onSubmit: (data: SubmitData) => void;
  initialDeliveryDate: string | Moment;
  orderID: string;
  error: any;
  setError: React.Dispatch<React.SetStateAction<any[]>>;
  isLoading: boolean;
}

const DeliveryDateModal: FC<DeliveryDateModalProps> = (props) => {
  const {
    onClose,
    onSubmit,
    initialDeliveryDate,
    orderID,
    setError,
    error,
    isLoading,
  } = props || {};

  const { t } = useTranslation();

  const [input, setInput] = useState<InputData>({
    deliveryDate: initialDeliveryDate,
  });

  const handleDateChange = (value: string, name: string) => {
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    try {
      const value = DeliveryDateModalSchema.validateSync(input);

      if (value) onSubmit({ deliveryDate: value.deliveryDate, orderID });
    } catch (err) {
      console.log(err);
      const { path, value } = errorHandler.validation(err);

      setError &&
        setError({
          ...error,
          [path]: t(`${value}`, { field: t(`label.${path}`) }),
        });
    }
  };

  return (
    <div className="delivery-date-modal">
      <div className="ddm-header">
        <div className="ddm-title">{t("title.changeDeliveryDate")}</div>
      </div>
      <div className="ddm-container">
        <DatePicker
          name="deliveryDate"
          label={t("label.deliveryDate")}
          value={input?.deliveryDate}
          onChange={(value) => handleDateChange(value, "deliveryDate")}
        />
        <AlertBox text={error?.deliveryDate} />
      </div>
      {error?.general && <div className="u-info u-error">{error.general}</div>}
      <div className="ddm-btn-container">
        <Button
          label={t("action.cancel")}
          isDisabled={isLoading}
          onClick={() => onClose()}
        />
        <Button
          label={t("action.submit")}
          type="primary"
          isLoading={isLoading}
          onClick={() => handleSubmit()}
        />
      </div>
    </div>
  );
};

export default DeliveryDateModal;
